import React, { useContext, useRef } from "react";
import { useState, useEffect } from "react";
import Modal from "@mui/material/Modal";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import {
  Box,
  FormControl,
  TextField,
  Button,
  Tooltip,
  Checkbox,
  Typography,
  FormControlLabel,
  FormHelperText,
} from "@mui/material";
import AuthContext from "../store/AuthContext";
import DownloadIcon from "@mui/icons-material/Download";
import html2pdf from "html2pdf.js";
import PinInput from "react-pin-input";
import ModalHeader from "../modals/ModalHeader";
import ModalFooter from "../modals/ModalFooter";
import { dilliPaysign, Logo } from "../iconsImports";
import { postJsonData } from "../network/ApiController";
import ApiEndpoints from "../network/ApiEndPoints";
import { useLocation } from "react-router-dom";
import useCommonContext from "../store/CommonContext";
import Loader from "../commons/Spinner";
import { datemonthYear, myDateDDMMTT, myDateDDMMyy } from "../utils/DateUtils";
import axios from "axios";
// Define the PDF document component
const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 12,
    lineHeight: 1.5,
  },
  section: {
    marginBottom: 10,
  },
  viewer: {
    width: window.innerWidth,
    height: window.innerHeight,
  },
  image: {
    width: 160,
  },
  stamp_image: {
    width: 200,
    marginLeft: -15,
  },
  bigtext: {
    fontSize: 200,
    letterSpacing: 0.4,
    lineHeight: 1.2,
  },
  text: {
    fontSize: 11,
    letterSpacing: 0.4,
    marginBottom: 30,
    lineHeight: 1.5,
    textAlign: "justify",
    wordWrap: "break-word",
  },
});

const DistributorAgreement = () => {
  const [open, setOpen] = useState(false);
  const [currentDateTime, setCurrentDateTime] = useState("");
  const [checked, setChecked] = useState(false);
  const [request, setRequest] = useState(false);
  const [aadhaar, setAadhaar] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [otpRefrance, setOtpRefrance] = useState("");
  const [message, setMessage] = useState("");
  const [showForPDF, setShowForPDF] = useState(false);
  const [date, setDate] = useState();
  const [otp, setOtp] = useState("");
  const [aadhaarError, setAadhaarError] = useState(false);
  const [otpError, setOtpError] = useState(false);
  const authCtx = useContext(AuthContext);
  const user = authCtx.user;
  const location = useLocation();
  const [ip, setIp] = useState("");
  const [isPhone, setIsPhone] = useState(false);
  const { getRecentData, refreshUser, userRequest } = useCommonContext();
  useEffect(() => {
    // Fetch the IP address
    const fetchIp = async () => {
      try {
        const response = await axios.get("https://api.ipify.org?format=json");
        setIp(response.data.ip);
      } catch (error) {
        console.error("Error fetching the IP address:", error);
      }
    };

    fetchIp();

    // Detect if the user is on a phone
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android|iPad|iPhone|iPod/.test(userAgent.toLowerCase())) {
      setIsPhone(true);
    }
  }, []);
  const queryParams = new URLSearchParams(location.search);

  const stateData = {
    rowData: queryParams.get("rowData"),
    ip: queryParams.get("ip"),
    type: queryParams.get("type"),
  };
  if (!stateData.rowData) {
    console.warn("rowData is not present in the URL query parameters.");
  }
  const contentRef = useRef();
  useEffect(() => {
    if (!stateData?.rowData) return; // Ensure stateData.rowData is available

    postJsonData(
      ApiEndpoints.AGEMENT_DATE,
      { id: stateData.rowData },
      setRequest,
      (res) => {
        setDate(res.data.data.created_at);
        setMessage(
          `This agreement  is electronically transmitted on ${myDateDDMMTT(
            date
          )} from IP address  ${stateData.ip}. and verified by (${
            user?.establishment
          }/${user?.name}) having PAN NO ${user?.pan} `
        );
        setChecked(true); // Update the state with the date
      },
      (err) => {
        console.error("Error fetching date:", err); // Handle errors
      }
    );
  }, [stateData?.rowData]); // Empty
  const handleDownload = () => {
    setShowForPDF(true);

    setTimeout(() => {
      document.getElementById("downloadButton").classList.add("hide-in-pdf");

      const element = contentRef.current;
      const options = {
        margin: [0.5, 0.5, 0.5, 0.5],
        filename: "Distributor_Agreement.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 3, letterRendering: true, useCORS: true },
        jsPDF: { unit: "in", format: "A4", orientation: "portrait" },
      };

      html2pdf()
        .set(options)
        .from(element)
        .save()
        .finally(() => {
          setShowForPDF(false);
          document
            .getElementById("downloadButton")
            .classList.remove("hide-in-pdf");
        });
    }, 500);
  };

  const getCurrentDateTime = () => {
    const date = new Date();

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year} `;
  };

  useEffect(() => {
    setCurrentDateTime(getCurrentDateTime());

    const interval = setInterval(() => {
      setCurrentDateTime(getCurrentDateTime());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  function handleChange(e) {
    setChecked(!checked);
    setOpen(!checked);
  }

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    // width: "40%",
    boxShadow: 24,
    fontFamily: "Poppins",
    height: "max-content",
    overflowY: "scroll",
    p: 2,
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setAadhaarError("");
    setOtpError("");

    // Aadhaar validation
    if (aadhaar.length !== 12) {
      setAadhaarError("Enter Valid Aadhaar Number");
      return;
    }

    // Helper function to get user's location
    const getLocation = (e) =>
      new Promise((resolve, reject) => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => resolve(position.coords),
            (error) => reject(error)
          );
        } else {
          reject(new Error("Geolocation is not supported by this browser."));
        }
      });

    try {
      // Retrieve user's location
      const { latitude, longitude } = await getLocation();

      // Send Aadhaar and location data (no OTP required)
      postJsonData(
        ApiEndpoints.SEND_OTP_Okyc, // You might want to rename the API endpoint if OTP is not being sent
        { aadhaarNumber: aadhaar, latitude, longitude },
        setRequest,
        (res) => {
          setOtpRefrance(res?.data?.data?.otpReferenceID);
          setIsOtpSent(true); // Set OTP sent status to true
        },
        (err) => {
          console.error("Error submitting Aadhaar", err);
          setAadhaarError("Error submitting Aadhaar. Please try again.");
        }
      );
    } catch (error) {
      console.error("Error fetching location:", error);
      setAadhaarError("Unable to fetch location. Please try again.");
    }
  };
  const verifyOTP = async (e) => {
    e.preventDefault();
    setOtpError("");
    const getLocation = () =>
      new Promise((resolve, reject) => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => resolve(position.coords),
            (error) => reject(error)
          );
        } else {
          reject(new Error("Geolocation is not supported by this browser."));
        }
      });
    if (!isOtpSent) {
      // If OTP is not sent, validate Aadhaar number
      if (aadhaar.length !== 12) {
        setAadhaarError("Enter Valid Aadhaar Number");
        return;
      }
      // Proceed with OTP sending if Aadhaar is valid
      try {
        const { latitude, longitude } = await getLocation();

        postJsonData(
          ApiEndpoints.SEND_OTP_Okyc,
          { aadhaarNumber: aadhaar, latitude, longitude },
          setRequest,
          (res) => {
            setOtpRefrance(res?.data?.data?.otpReferenceID);
            setIsOtpSent(true); // Set OTP sent status
          },
          (err) => {
            console.error("Error sending OTP", err);
            setOtpError("Error sending OTP. Please try again.");
          }
        );
      } catch (error) {
        console.error("Error fetching location:", error);
        setOtpError("Unable to fetch location. Please try again.");
      }
    } else {
      // OTP verification block
      if (otp.length === 6) {
        try {
          const { latitude, longitude } = await getLocation();

          // Verify OTP
          postJsonData(
            ApiEndpoints.VERIFY_OTP_OKYC,
            { otp, otpReferenceID: otpRefrance, latitude, longitude },
            setRequest,
            (res) => {
              console.log("OTP verified successfully", res);
              setMessage(
                `This agreement  is electronically transmitted on ${myDateDDMMTT(
                  date
                )} from IP address ${stateData.ip}. and verified by (${
                  user?.establishment
                }/${user?.name}) having PAN NO ${user?.pan} `
              );
              setChecked(true);
              handleDownload();
              refreshUser();
              handleClose();
            },
            (err) => {
              console.error("Error verifying OTP", err);

              const apiError = err?.response?.data?.message;

              setOtpError(` ${apiError}`);
            }
          );
        } catch (error) {
          console.error("Error fetching location:", error);
        }
      } else {
        setOtpError("Enter a valid OTP.");
      }
    }
  };

  const handleCloseModel = () => {
    setAadhaar("");
    setOtp("");
    setIsOtpSent(false);
    setChecked(false);
    setOpen(false);
  };
  const handleClose = () => {
    setAadhaar("");
    setOtp("");
    setIsOtpSent(false);
    setOpen(false);
  };
  return (
    <>
      <div
        ref={contentRef}
        style={{
          padding: "20px",
          flexGrow: 1,
          fontFamily: "Arial, sans-serif",
          lineHeight: "1.6",
          maxWidth: "800px",
          margin: "0 auto",
          color: "#333",
          textAlign: "justify",
          overflowWrap: "break-word",
          wordWrap: "break-word",
          whiteSpace: "normal",
        }}
      >
        <Page size="A4" style={styles.page}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "20px",
              marginBottom: "10px",
            }}
          >
            {/* Logo on Left */}
            <img
              src={Logo} // ✅ Replace with actual logo path
              alt="DilliPay Logo"
              style={{
                width: "30%",
                height: "70px",
                marginRight: "15px",
              }}
            />

            <div style={{ textAlign: "center", flexGrow: 1 }}>
              <h2
                style={{
                  fontSize: "22px",
                  fontWeight: "bold",
                  margin: 0,
                }}
              >
                DILLIPAY TECHNOLOGIES LIMITED
              </h2>
              <p
                style={{
                  fontSize: "14px",
                  margin: "5px 0 0 0",
                }}
              >
                Plot No. 5, Second Floor, Pocket -5, Rohini Sector 24, New Delhi
                – 110085
              </p>
            </div>
          </div>
          <hr
            style={{
              border: "1px solid black",
              // marginBottom: "10px",
            }}
          />

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              textAlign: "center",
              marginTop: "20px",
            }}
          >
            <h1
              style={{
                alignItems: "center",
                textAlign: "center",
                marginBottom: "20px",
                fontSize: "24px",
                flexGrow: 1,
                textDecoration: "underline", // ✅ Added underline
              }}
            >
              DISTRIBUTOR / MASTER DISTRIBUTOR AGREEMENT
            </h1>

            <Tooltip title="Download as PDF" arrow>
              <Button
                id="downloadButton"
                onClick={handleDownload}
                style={{
                  minWidth: "auto",
                  padding: 8,
                  mb: 1,
                  // backgroundColor: "black",
                }}
              >
                <DownloadIcon style={{ color: "black" }} />
              </Button>
            </Tooltip>
          </div>
          <p
            style={{
              fontStyle: "italic",
              textAlign: "center",
              marginBottom: "20px",
            }}
          >
            THIS Agreement is made as of this Between:
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            <strong>DILLIPAY TECHNOLOGIES LIMITED</strong>, a company
            incorporated under The Companies Act, 2013, having its registered
            office at Plot No 5, Second Floor, Pocket 5, Sector 24, Rohini,
            Delhi-110085.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            (Hereinafter referred to as “DilliPay” which expression shall unless
            repugnant to the context or meaning thereof, include their
            successors and permitted assigns) of the ONE PART
          </p>
          <strong style={{ marginLeft: "20px" }}>AND</strong>

          <p style={{ marginBottom: "30px", marginLeft: "20px" }}>
            <strong>
              {user.establishment} ,{user.id} , {user.name}, {user.username}
            </strong>{" "}
            (Hereinafter referred to as "DISTRIBUTOR", which expression shall
            unless repugnant to the context or meaning thereof, include their
            successors and permitted assigns) of the SECOND PART.
          </p>
          <p style={{ marginLeft: "20px" }}>
            The DilliPay and the Distributor are herein collectively referred to
            as the “Parties” and individually as a “Party.”
          </p>
          <h2
            style={{
              marginTop: "40px",
              marginBottom: "10px",
              fontSize: "20px",
              marginLeft: "20px",
            }}
          >
            WHEREAS
          </h2>
          <ul style={{ paddingLeft: "40px", marginBottom: "30px" }}>
            <li style={{ marginBottom: "15px" }}>
              <strong>A.</strong> DilliPay is a technology-based company
              engaged, inter alia, provides the software/platform services in
              the business of the Fintech industry and caters to a number of
              services like Domestic Money Transfer, Aadhaar Enabled Payment
              System, Utility Bill payments, Recharge, Travel, and many more.
            </li>
            <li style={{ marginBottom: "15px" }}>
              <strong>B.</strong> DilliPay proposes to appoint Distributor(s) in
              various cities and regions of India for the purpose of managing
              retailers to be appointed by DilliPay in such cities and regions
              and to perform various services offered by DilliPay. Such
              Distributor may be referred to as Master Distributor (MD) or
              Distributor (DI).
            </li>
            <li style={{ marginBottom: "15px" }}>
              <strong>C.</strong> The Distributor wishes to be appointed as the
              Distributor in the DilliPay-designated regional territory
              (hereinafter referred to as "Territory") on the terms & conditions
              contained in this Distributor Agreement. The Parties agree and
              undertake that they shall abide by the terms and conditions
              contained in this Distributor Agreement and therefore agree to
              sign this Distributor Agreement confirming their commitment and
              intentions in respect thereof.
            </li>
          </ul>
          <h2
            style={{
              marginTop: "40px",
              marginBottom: "10px",
              fontSize: "20px",
              marginLeft: "20px",
            }}
          >
            1. APPOINTMENT OF THE DISTRIBUTOR
          </h2>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            Subject to the terms and conditions contained in this Distributor
            Agreement, DilliPay hereby appoints the Distributor as the
            Distributor of DilliPay on a non-exclusive basis for the Territory
            to provide the services mentioned in Annexure-I (hereinafter
            referred to as "Services"), and the Distributor hereby agrees to
            provide the Services.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            DilliPay proposes to appoint Distributor (s) in the various cities
            and regions of the India for the purpose of managing retailers to be
            appointed by DilliPay in such cities and regions and to perform
            various services offered by DilliPay, and such Distributor may be
            referred to as Master Distributor (MD) or Distributor (DI).
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            The Distributor may describe themselves as DilliPay’s authorized
            distributor, but must not hold themselves out as being entitled to
            bind DilliPay in any way.
          </p>
          <h2
            style={{
              marginTop: "40px",
              marginBottom: "10px",
              fontSize: "20px",
              marginLeft: "20px",
            }}
          >
            2. COMMENCEMENT TERM AND RENEWAL
          </h2>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            a: The Distributor shall commence business in accordance with the
            terms and conditions of this Distributor Agreement within 15 days
            from the date of signing this Distributor Agreement.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            b: This Distributor Agreement shall be valid for a period of 9
            (nine) years unless terminated by DilliPay or Distributor, in
            accordance with clause 13 of this Distributor Agreement. The period
            of validity of this Distributor Agreement shall be referred to as
            the "Term".
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            c: Upon the expiry of the Term and subject to satisfactory
            performance of the services by the Distributor, the Distributor
            Agreement may be renewed at DilliPay’s option, on mutually agreed
            terms and conditions.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            d: DilliPay may exercise its right to renew this Distributor
            Agreement by informing one month prior to the completion of Term of
            this Distributor Agreement.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            e: The Distributor shall ensure that the Distributor Agreement is
            renewed from time to time.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            The Distributor agrees and acknowledges that it shall not do any
            business without a valid Distributor Agreement with DilliPay.
            Distributor agrees and acknowledges that the DilliPay shall not be
            responsible or liable in any manner whatsoever, if the Distributor
            Agreement is not renewed and the Distributor continues to do
            business during such period whereof there is no valid Distributor
            Agreement between the parties.
          </p>
          <h2
            style={{
              marginTop: "40px",
              marginBottom: "10px",
              fontSize: "20px",
              marginLeft: "20px",
            }}
          >
            3. PROVISION OF SERVICES
          </h2>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            During the Term, the Distributor shall render to DilliPay (by
            through such of its offices, employees, agents, representatives and
            affiliates that Distributor shall designate from time to time)
            services as defined in Annexure-I.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            Not with standing anything to the contrary contained in this
            Distributor Agreement, DilliPay shall have the right to modify,
            alter and amend the list of the Services at any time, including the
            manner in which the Distributor will be required to perform the
            Services. The Distributor shall be bound by all such modifications
            and amendments made by DilliPay.
          </p>
          <h2
            style={{
              marginTop: "40px",
              marginBottom: "10px",
              fontSize: "20px",
              marginLeft: "20px",
            }}
          >
            4. BUSINESS PLAN AND RETAILERS
          </h2>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            The Parties shall mutually agree upon a Business Plan in relation to
            sourcing of retailers to be appointed by the DilliPay, which shall
            include, inter alia, the minimum number of persons that the
            Distributor shall introduce to DilliPay for the appointment as
            retailers. The Distributors shall agree to introduce retailers as
            per the Business Plan agreed to between Parties. In the event, that
            the Distributors unable to introduce the specified number of persons
            to DilliPay to be appointed as retailers, DilliPay reserves the
            right to appoint an additional Distributor in the Territory or to
            terminate this Distributor Agreement.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            The Distributor acknowledges and agrees that it is solely
            responsible for issuing credit money to the retailers and to
            withdrawing credit money from the retailers in its Territory, and
            DilliPay is not responsible for any error or dispute arising out of
            such transactions in any manner whatsoever.
          </p>
          <h2
            style={{
              marginTop: "40px",
              marginBottom: "10px",
              fontSize: "20px",
              marginLeft: "20px",
            }}
          >
            5. PAYMENT AND COMMISSION
          </h2>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            a:The Distributor shall deposit a sum of INR [……….../=] [……..in
            words……...] with the DilliPay on or before the effective date. The
            deposit shall be non-interest bearing and shall be refunded at the
            time of termination of the Distributor Agreement in accordance with
            the provision defined in clause 14 (Consequences of Termination) of
            this Distributor Agreement.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            b:The Distributor acknowledges that the DilliPay may reject the
            deposit at its sole discretion on or before the effective date.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            c:In addition to the deposit, the Distributor shall maintain and
            deposit with the DilliPay, working capital to the extent of INR
            [……….../=] [……..in words……...], which shall also be
            non-interest-bearing. The working capital shall be utilized to
            provide credit to the retailers appointed by the DilliPay in the
            Territory, and who (retailers) are managed by the Distributor.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            d:Distributor agrees and acknowledges that the DilliPay shall not be
            responsible or liable in any manner whatsoever for the sources of
            such deposits and/or working capital, and it is the sole
            responsibility of the Distributor to ensure that the sources of such
            deposits and/or working capital are legitimate and are in accordance
            with the law of India.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            e: All the amount due to DilliPay under this Distributor Agreement,
            including the deposit and working capital and/or platform fee, shall
            be deposited in accordance with the instructions provided in
            Annexure-II. Distributor agrees and acknowledges that the DilliPay
            may, by prior written notice of two business days, modify any of the
            details mentioned in Annexure-II and the Distributor shall be bound
            by all such modifications.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            f: Distributor acknowledges and agrees that DilliPay strictly
            prohibits any third-party deposits in any bank accounts via any mode
            whatsoever. In the event that Distributor or its Retailer indulges
            in any such transaction(s) knowingly or unknowingly, the Distributor
            authorizes DilliPay to freeze its account immediately.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            g: Distributor shall be entitled to the commission, discount or
            service fee, or such other remuneration referred in the Services, as
            may be specified by the DilliPay, from time to time and published on
            DilliPay’s portal. All the amounts paid by way of the commission
            shall be exclusive to all applicable taxes, including goods and
            service tax, surcharge, cess etc., by whatsoever name called, and
            such taxes will be subject to the deduction of tax at source, if
            applicable; DilliPay shall debit the account of the Distributor to
            the extent of such taxes.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            h: The commission shall accrue to the Distributor only on receipt
            and realization of full payment by the DilliPay of all dues from the
            retailers who are managed by the Distributor.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            i:The commission so accrued shall be paid to the Distributor on a
            monthly basis by way of bank transfer or additional credit in the
            working capital.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            j: Payments made to the Distributor shall be subject to such
            withholding as prescribed under the applicable law, subject to the
            aforesaid, DilliPay assumes no responsibility for the tax compliance
            of the Distributor.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            k: The Distributor agrees that payments made to the Distributor
            shall be subject to the deduction of chargeback/ complaint against
            the AEPS transactions, Payment Gateway transactions and / or QR code
            transactions or any deposit or withdrawal transaction any other
            transactions whatsoever.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            l:The Distributor agrees and authorizes DilliPay to impose cash
            deposit bank charges which shall be subject to deduction from the
            payments made to the Distributor.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            m: All costs and expenses for travelling, promotional activities and
            other similar out-of-pocket expenses incurred in the performance of
            the Services shall be borne by the Distributor.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            n:Distributor agrees and acknowledges that in case of any deviation
            with respect to the use of key salt, it shall be solely liable and
            responsible; and in such event, DilliPay is authorized to
            immediately deactivate the account of Distributor without any prior
            notice. DilliPay shall not be held responsible for any consequences
            that arise out of any unauthorized use of its platform in any
            manner.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            o:The Distributor agrees and authorizes DilliPay to freeze its
            account or account of its Retailer in the event DilliPay receives
            any complaint from any relevant statutory or non-statutory authority
            or any government department or agency. The Distributor further
            agrees and authorizes DilliPay to withdraw the disputed amount along
            with the anticipated penalty from the such frozen account.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            p:Distributor agrees and acknowledges that all the sales/ receipts
            of the distributor regarding the DilliPay shall be immediately
            Deposit or transfer of the funds into the designated Bank Accounts
            of the DilliPay and shall get limit from the Company/ DilliPay
            thereafter. The Distributor shall ensure that the working limit in
            the portal by DilliPay against the cash deposit or funds transfer is
            made available to the distributor immediately. The Distributor shall
            inform to the Company/ DilliPay in predefined format, if the
            distributor fails to inform the same within seven calendar days the
            amount will be forfeit by the Company/ DilliPay. Distributor may
            deposit such cash self or via its employee or agent or any
            authorized person into the designated Bank Accounts of the DilliPay.
          </p>
        </Page>
        <Page size="A4" style={styles.page}>
          <h2
            style={{
              marginTop: "40px",
              marginBottom: "10px",
              fontSize: "20px",
              marginLeft: "20px",
            }}
          >
            6. OPERATIONS OF THE DISTRIBUTOR
          </h2>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            The Distributor shall operate and provide the Services from its
            independent offices equipped with the necessary infrastructure and
            workforce required to provide the Services. The Distributor shall
            provide a prior written intimation of any changes in the location of
            such office to DilliPay.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            DilliPay may, at its discretion, provide advice to the Distributor
            in relation to exteriors and interiors of the Distributor’s office,
            investment information technology systems, basic accounting and
            business procedure etc. The Distributor shall be bound by such
            advice of DilliPay.
          </p>

          <h2
            style={{
              marginTop: "40px",
              marginBottom: "10px",
              fontSize: "20px",
              marginLeft: "20px",
            }}
          >
            7. MARKET INTELLIGENCE
          </h2>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            The Distributor shall develop adequate and relevant market
            intelligence in relation to the Territory and shall inform DilliPay
            from time to time about the activities of other persons/companies
            engaged in a similar business.
          </p>

          <h2
            style={{
              marginTop: "40px",
              marginBottom: "10px",
              fontSize: "20px",
              marginLeft: "20px",
            }}
          >
            8. EMPLOYEES OF DISTRIBUTOR
          </h2>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            a:The Distributor shall engage the minimum number of personnel as
            specified by the DilliPay and such other additional personnel as may
            be required to effectively provide the Services. The Distributor
            shall ensure that all personnel employed in the provision of the
            Services shall be adequately trained and shall comply with the Term
            of this Distributor Agreement. The Distributor agrees and
            acknowledges that it shall do proper due diligence and background
            check of all such personnel.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            b:The Distributor shall be liable and responsible for any data theft
            or misuse of any data related to clients of DilliPay from its
            office.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            c:The Distributor agrees and acknowledges that DilliPay will not
            have any obligations, liability or responsibility whatsoever to
            supervise or manage the Distributor's employees, agents or
            independent contractors.
          </p>

          <h2
            style={{
              marginTop: "40px",
              marginBottom: "10px",
              fontSize: "20px",
              marginLeft: "20px",
            }}
          >
            9. INTELLECTUAL PROPERTY
          </h2>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            a:DilliPay hereby grants the Distributor a limited, non-exclusive,
            non-transferable, non-assignable and royalty- free license to use
            the Software for the purpose of providing the Services as
            contemplated under this Distributor Agreement, which may be revoked
            by DilliPay at its sole discretion.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            b:The Distributor is expressly prohibited from distributing,
            sub-licensing, assigning, transferring or otherwise the Software, or
            other technical documentation pertaining thereto, or any portions
            thereof in any form to any person.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            c:The Distributor may utilize any third-party software other than
            the Software provided by DilliPay,only with prior permission from
            DilliPay.Further,the Distributor shall ensure that the third-party
            software is validly licenced and installed.
          </p>

          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            d:The DilliPay shall retain all the rights over all the intellectual
            property, including the Software, its name and logo and all the
            rights in relation to the promotion and marketing materials. The
            Distributor hereby acknowledges that (a) the execution of this
            Distributor Agreement does not amount to any transfer to it of any
            intellectual property rights held by the DilliPay prior to the
            execution of this Distributor Agreement, nor does this Distributor
            Agreement in any way limit the DilliPay’s rights over its
            intellectual property, including the right to licence to others and,
            (b) any and all goodwill arising from the Distributor’s use of the
            intellectual property shall be exclusive ofDilliPay without any
            compensation to anyone.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            e:The Distributor shall not use the Software of the DilliPay in any
            manner whatsoever without the written permission of the DilliPay.
          </p>
        </Page>
        <Page size="A4" style={styles.page}>
          <h2
            style={{
              marginTop: "40px",
              marginBottom: "10px",
              fontSize: "20px",
              marginLeft: "20px",
            }}
          >
            10. CONFIDENTIALITY
          </h2>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            a:Parties undertake to retain in confidence the terms of this
            Distributor Agreement and all other non-public information,
            technology, materials, and know-how of the other party disclosed to
            or acquired by the receiving party pursuant to or in connection with
            this Distributor Agreement that is either designated as proprietary
            or confidential or by the nature of the circumstances surrounding
            disclosure, ought in good faith to be treated as proprietary or
            confidential information, provided that each party may disclose the
            terms and conditions of this Distributor Agreement to its immediate
            legal and financial consultants in the ordinary course of its
            business.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            b:That Distributor agrees and acknowledges that the DilliPay has a
            responsibility to its customers to keep customer information
            strictly confidential. The Distributor agrees and acknowledges to
            keep all information related to customers strictly confidential that
            the Distributor is in the possession, or gains access to or become
            aware of during the course of rendering the services under this
            Distributor Agreement.
          </p>
          {/* <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            The provision of clause 10 shall survive the expiry of termination
            of this Distributor Agreement.
          </p> */}
          <h2
            style={{
              marginTop: "40px",
              marginBottom: "10px",
              fontSize: "20px",
              marginLeft: "20px",
            }}
          >
            11. COMPETITION AND SOLICIT
          </h2>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            a:The Distributor agrees and undertakes that during the Term of
            Distributor Agreement and for a period of one year thereafter, it
            shall not, directly, through its employees, affiliates or relatives
            or in a firm where the Distributor or any relative or nominee of the
            Distributor is a partner or in any company where the Distributor or
            any relative or nominee of the Distributor is a director or
            shareholder,
            <br />
            1.) be appointed as a Distributor for any other person or legal
            entity which is carrying on a business similar or in competition
            with any business carried by DilliPay at the relevant time, whether
            in India or abroad, or
            <br />
            2.) engage in any business that is similar to or in competition with
            any business carried on by the DilliPay at the relevant time.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            b:During the Term of Distributor Agreement, the Distributor shall
            not either directly or indirectly solicit any employee of DilliPay
            for employment, induce or attempt to induce any such employee to
            terminate or breach his or her employment agreement with DilliPay,
            or hire any such employee or associate with any such employee,
            either during the course of their employment with DilliPay or after
            the termination of their employment with the DilliPay.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            c:During the Term of this Distributor Agreement, the Distributor
            shall not either directly or indirectly, solicit, cause in any part
            or knowingly encourage any existing or potential clients or
            customers of DilliPay to cease doing business or not to do business,
            in whole or in part of with DilliPay, or solicit, cause in any part
            or knowingly encourage any existing or potential clients or
            customers of DilliPay to do business with any person other then
            DilliPay, or associate with any prospective clients or customers
            while they continue to be clients or customers of DilliPay
          </p>
          <h2
            style={{
              marginTop: "40px",
              marginBottom: "10px",
              fontSize: "20px",
              marginLeft: "20px",
            }}
          >
            12. EXCLUSIVITY
          </h2>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            The Distributor shall only market and promote Services of DilliPay,
            as authorized by the DilliPay.
          </p>
          <h2
            style={{
              marginTop: "40px",
              marginBottom: "10px",
              fontSize: "20px",
              marginLeft: "20px",
            }}
          >
            13. TERMINATION OF AGREEMENT
          </h2>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            DilliPay may terminate this Distributor Agreement of the Distributor
            with immediate effect, if
          </p>
          <ul style={{ paddingLeft: "40px", marginBottom: "30px" }}>
            <li style={{ marginBottom: "15px" }}>
              a. In the opinion of DilliPay, the Distributor is not a fit person
              to perform Services under the provision of this Distributor
              Agreement.
            </li>
            <li style={{ marginBottom: "15px" }}>
              b. Distributor fails to deposit the proceeds of sale/ receipts
              made by the Distributor or its retailers to DilliPay on a daily
              basis and perpetual basis.
            </li>
            <li style={{ marginBottom: "15px" }}>
              c. Distributor becomes the subject of a voluntary petitioner in
              bankruptcy or any voluntary proceedings relating to insolvency,
              liquidation or composition for the benefit of the creditors.
            </li>
            <li style={{ marginBottom: "15px" }}>
              d.Distributor fails to comply with directions issued by the
              DilliPay under the provision of this Distributor Agreement.
            </li>
            <li style={{ marginBottom: "15px" }}>
              e.Not with standing anything to the contrary herein, DilliPay may
              terminate this Distributor Agreement without notice.
            </li>
          </ul>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            Notwithstanding anything to the contrary herein, DilliPay may
            terminate this Distributor Agreement without notice.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            Distributor may terminate this Distributor Agreement with written
            notice of 60 (sixty) days to DilliPay.
          </p>
          <h2
            style={{
              marginTop: "40px",
              marginBottom: "10px",
              fontSize: "20px",
              marginLeft: "20px",
            }}
          >
            14. CONSEQUENCE OF TERMINATION
          </h2>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            Upon termination of this Distributor Agreement for any reason as
            stated in clause 13 above, the Distributor shall
          </p>
          <ul style={{ paddingLeft: "40px", marginBottom: "30px" }}>
            <li style={{ marginBottom: "15px" }}>
              a. Immediately discontinue and cease to use the trademark, logo,
              other intellectual property, and Software provided by DilliPay,
              and shall immediately hand over all copies or documents of such
              intellectual property to DilliPay.
            </li>
            <li style={{ marginBottom: "15px" }}>
              b. Immediately return to DilliPay all confidential information,
              originals, and copies of any and all materials provided to the
              Distributor under this Distributor Agreement or in the course of
              provision of the services.
            </li>
            <li style={{ marginBottom: "15px" }}>
              c. Immediately provide remote access to DilliPay to disable any
              Software that DilliPay has installed with the Distributor.
            </li>
            <li style={{ marginBottom: "15px" }}>
              d. Immediately remove all signboards, banners, and glowboards of
              DilliPay from its offices, along with any materials indicating an
              association with DilliPay.
            </li>
            <li style={{ marginBottom: "15px" }}>
              e. Immediately cease to promote, market, or advertise DilliPay or
              its products/services.
            </li>
            <li style={{ marginBottom: "15px" }}>
              f. Immediately clear all dues within a period of 7 days from the
              date of termination.
            </li>
          </ul>
          <h2
            style={{
              marginTop: "40px",
              marginBottom: "10px",
              fontSize: "20px",
              marginLeft: "20px",
            }}
          >
            15. INDEMNITY,LIABILITY AND COMPILANCE
          </h2>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            A:Indemnity:
            <br />
            The Distributor shall indemnify, defend, and hold liPay Technologies
            Limited (“DilliPay”), its financial partners, affiliates, officers,
            directors, employees, successors, and assigns, from and against any
            and all customer claims, actions, demands, litigations, suits,
            proceedings, losses, expenses, costs, damages, charges, or penalties
            arising out of or in connection with:
            <br />
            a:wilful misconduct or nece of the Retailer;
            <br />
            b: fraud or misrepresentation by the Retailer;
            <br />
            c:breach of applicablelaws, regulations, or guidelines; or
            <br />
            d:breach of any terms or conditions of this Retailer Agreement,
            directly attributable to the Retailer.
          </p>
          <h2
            style={{
              marginTop: "40px",
              marginBottom: "10px",
              fontSize: "20px",
              marginLeft: "20px",
            }}
          >
            Limitation of Liability:
          </h2>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            Not with standing anything contained herein, DilliPay shall not be
            liable to the Distributor for any incidental, indirect, special,
            punitive, or consequential damages, including but not limited to
            loss of revenue, profits, goodwill, or business opportunities, even
            if advised of the possibility of such damages.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            <span style={{ fontWeight: "bold" }}>
              a: Anti-Money Laundering (AML) Compliance{" "}
            </span>
            : The Retailer shall ensure that the DilliPay platform or services
            are not used for money laundering and shall comply with all
            applicable AML and counter-terrorism financing laws, including but
            not limited to the Prevention of Money Laundering Act, 2002, and the
            rules, regulations, and guidelines issued thereunder by competent
            authorities.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            <span style={{ fontWeight: "bold" }}>
              b: Prohibited Transactions:
            </span>
            The Distributor undertakes not to permit, process, or entertain any
            transfer of money or transaction through the DilliPay platform or
            services in relation to:
            <li>
              narcotic drugs, psychotropic substances, or illegal
              pharmaceuticals;
            </li>
            <li>arms, ammunition, explosives, or weapons;</li>
            <li>terrorism financing or terrorist activities;</li>
            <li>money laundering or illegal fund transfers;</li>
            <li>counterfeiting of currency, securities, or goods;</li>
            <li>
              unauthorized cross-border transactions in violation of
              <span style={{ fontWeight: "bold" }}>
                Foreign Exchange Management Act, 1999 (FEMA);
              </span>
            </li>
            <li>any unlawful purpose or illegal activity; or ;</li>
            <li>
              any article, object, or material prohibited under the laws of
              India or by the Government of India.
            </li>
          </p>

          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            <span style={{ fontWeight: "bold" }}>
              c: Prohibited Misuse of Platform
            </span>
            The Distributor undertakes that it shall not use or misuse the
            DilliPay technology platform for:
          </p>
          <ul style={{ paddingLeft: "60px", marginBottom: "30px" }}>
            <li style={{ marginBottom: "15px" }}>
              Splitting a single transaction into multiple transactions with the
              intent to earn additional commission;
            </li>
            <li style={{ marginBottom: "15px" }}>
              Engaging in financial transactions that result in the circular
              movement or round-tripping of funds;
            </li>
            <li style={{ marginBottom: "15px" }}>
              Selling, disclosing, or sharing any customer information
              (including KYC details or contact information) with third parties;
              or
            </li>
            <li style={{ marginBottom: "15px" }}>
              Making unauthorized copies (digital or physical) of any customer
              forms, documents, photographs, or identification materials,
              whether used or unused.
            </li>
          </ul>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            <span style={{ fontWeight: "bold" }}>d:Survival:</span>: The The
            obligations under this Clause shall survive the expiry or
            termination of this Distributor Agreement and shall remain valid in
            respect of any claims, liabilities, or disputes arising during the
            subsistence of this Agreement.
          </p>
          <div style={{ marginLeft: "20px", marginBottom: "40px" }}>
            <strong>
              e:Retention of KYC and Related Documentation – Legal and
              Regulatory Compliance Clause
            </strong>
            <p style={{ marginBottom: "15px", textAlign: "justify" }}>
              Pursuant to the applicable provisions of Indian law and in strict
              compliance with the directions, notifications, and circulars
              issued by competent statutory and regulatory authorities—including
              but not limited to the Ministry of Finance, Reserve Bank of India
              (RBI), Securities and Exchange Board of India (SEBI), Insurance
              Regulatory and Development Authority of India (IRDAI), Food Safety
              and Standards Authority of India (FSSAI), and any other
              sector-specific regulators—all retailers, distributors, agents,
              intermediaries, and associated business entities are legally
              obligated to collect, maintain, and preserve Know Your Customer
              (KYC) records and all related documents pertaining to any
              consumer, client, retailer, distributor, supplier, or any other
              related party.
            </p>

            <p style={{ fontWeight: "bold", marginBottom: "10px" }}>
              These records shall include, but are not limited to:
            </p>
            <ul style={{ paddingLeft: "60px", marginBottom: "20px" }}>
              <li>Identity and address proofs;</li>
              <li>PAN and/or Aadhaar information (as per applicable norms);</li>
              <li>Business registration documents;</li>
              <li>Transactional history;</li>
              <li>Communication logs and agreements;</li>
              <li>
                Any additional documentation required under statutory
                obligations or internal due diligence procedures.
              </li>
            </ul>

            <p style={{ fontWeight: "bold", marginBottom: "10px" }}>
              In accordance with the record-keeping obligations under:
            </p>
            <ul style={{ paddingLeft: "60px", marginBottom: "20px" }}>
              <li style={{ fontWeight: "bold" }}>
                Section 12 of the Prevention of Money Laundering Act, 2002 and
                Rule 3 of the PML Rules, 2005;
              </li>
              <li style={{ fontWeight: "bold" }}>
                Section 44AA and Rule 6F of the Income Tax Rules, 1962;
              </li>
              <li style={{ fontWeight: "bold" }}>
                Sections 128 and 129 of the Companies Act, 2013;
              </li>
              <li>Relevant RBI/SEBI/IRDAI/FSSAI circulars and guidelines;</li>
              <li>
                <strong>The Digital Personal Data Protection Act, 2023</strong>
                and associated rules concerning data retention and security;
              </li>
            </ul>

            <p style={{ marginBottom: "10px" }}>
              All such records{" "}
              <strong>
                must be retained for a minimum statutory period of ten (10)
                years
              </strong>{" "}
              from the date of:
            </p>
            <ul style={{ paddingLeft: "60px", marginBottom: "20px" }}>
              <li>The last transaction;</li>
              <li>Termination of the business relationship; or</li>
              <li>
                Closure of the account or engagement — whichever is later.
              </li>
            </ul>

            <p style={{ fontWeight: "bold", marginBottom: "10px" }}>
              Furthermore, entities must ensure that:
            </p>
            <ul style={{ paddingLeft: "60px", marginBottom: "20px" }}>
              <li>
                Records are <strong>stored securely </strong>in physical and
                electronic form;
              </li>
              <li>
                <strong>Access is strictly controlled </strong>and limited to
                authorized personnel;
              </li>
              <li>
                Adequate{" "}
                <strong>data protection and cybersecurity measures </strong> are
                in place to prevent unauthorized access, alteration, or
                disclosure, in accordance with the provisions of the DPDP Act
                and other applicable privacy laws.
              </li>
            </ul>

            <p style={{ textAlign: "justify" }}>
              Failure to comply with the above-stated obligations may attract
              <strong>penal provisions</strong> under the respective statutes,
              including but not limited to{" "}
              <strong>
                monetary fines, cancellation of licenses or registrations,
                prosecution, and other enforcement actions
              </strong>{" "}
              as deemed fit by the concerned authority.
            </p>
          </div>
          <h2
            style={{
              fontSize: "20px",
              marginLeft: "20px",
            }}
          >
            16. RELATIONSHIP BETWEEN THE PARTIES{" "}
          </h2>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            The Services rendered by the Distributor under this Distributor
            Agreement shall be provided as an independent contractor to
            DilliPay, and nothing in this Distributor Agreement creates or shall
            be deemed to create the relationship of partners, joint venture,
            employees or principle-agent between the Parties.
          </p>
        </Page>

        <Page size="A4" style={styles.page}>
          <h2
            style={{
              marginTop: "40px",
              marginBottom: "10px",
              fontSize: "20px",
              marginLeft: "20px",
            }}
          >
            17. RECORDS AND AUDIT{" "}
          </h2>

          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            a:The Distributor shall maintain all statutory books as may be
            required from time to time to be maintained under the all applicable
            laws.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            b:The Distributor shall permit the DilliPay, to enter into and
            inspect all books of accounts, record and materials in relation to
            the business operations related to this Distributor Agreement during
            normal business hours.
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            c:The Distributor shall ensure that KYC details/minimum details (as
            applicable) provided by the Customers be verified and carry out
            proper due diligence in the manner as instructed by the company in
            this regard. The Distributor shall be solely responsible for the
            verification process of KYC details/minimum details of the Customers
            and the Distributor/Aggregator hereby agrees that it shall be liable
            to indemnify the company in case of any losses or claims or
            penalties arising out of defective KYC verification process of the
            Customers for any transaction or any process regarding the platform
            or services of the company/ DilliPay.{" "}
          </p>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            d:During the Term and at any time within sixty days after the
            termination of this Distributor Agreement, DilliPay, through its
            employees, representatives or agents, may, at its expense, carry out
            an audit to determine whether the audit has properly completed its
            obligations under this Distributor Agreement.
          </p>

          <h2
            style={{
              marginTop: "40px",
              marginBottom: "10px",
              fontSize: "20px",
              marginLeft: "20px",
            }}
          >
            18. AMENDMENT
          </h2>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            No changes, alterations, modifications or additions to this
            Distributor Agreement shall be valid unless made in writing and
            properly executed by Parties hereto, however the changes,
            alterations, modifications or additions in agreement is binding to
            both parties if such changes etc shall be available on the platform
            of the company/ DilliPay.
          </p>

          <h2
            style={{
              marginTop: "40px",
              marginBottom: "10px",
              fontSize: "20px",
              marginLeft: "20px",
            }}
          >
            19. ASSIGNMENT
          </h2>
          <div style={{ marginLeft: "20px", marginBottom: "30px" }}>
            <p style={{ marginBottom: "20px" }}>
              <strong>a:</strong> The Distributor shall not assign, sub-let, or
              subcontract any of its obligations under this Distributor
              Agreement to any third party unless it obtains prior written
              permission/consent from DilliPay. In any event, any assignment or
              transfer shall not operate to relieve the assigning party of any
              of its obligations hereunder, nor will any such assignment impose
              any obligation on the assignee except in the case of express
              written assumption by the assignee.
            </p>

            <p style={{ marginBottom: "20px" }}>
              <strong>b:</strong> No such assignment under this clause shall
              relieve the Distributor of any obligations or liabilities incurred
              prior to the assignment unless mutually agreed to in writing.
            </p>

            <p style={{ marginBottom: "20px" }}>
              <strong>c:</strong> This Agreement shall be construed in
              accordance with the applicable laws in India.
            </p>
          </div>

          <h2
            style={{
              marginTop: "40px",
              marginBottom: "10px",
              fontSize: "20px",
              marginLeft: "20px",
            }}
          >
            20. COMMUNICATION
          </h2>
          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            The Distributor hereby agrees that being a DilliPay Distributor,
            DilliPay may communicate include communications including but not
            limited to voice, email, SMS, digital video, and / or any mode of
            innovative communication method, as deemed fit and proper by the
            company/ Dillipay.
          </p>
          <h2
            style={{
              marginTop: "40px",
              marginBottom: "10px",
              fontSize: "20px",
              marginLeft: "20px",
            }}
          >
            21. CHARGEBACK
          </h2>

          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            Upon receipt of a Chargeback notification from the Acquirer or the
            Issuer, Dillipay shall forthwith notify the Client. The Client shall
            have the right to submit to Dillipay, within five (5) days from such
            notification (or within such other period as may be specified by the
            Acquirer), documentary evidence and information (“Chargeback
            Documents”) substantiating the completion of the underlying
            transaction and/or the delivery of goods or services to the
            Customer. In the event the Client fails to furnish the Chargeback
            Documents within the stipulated period, or if the Issuer, at its
            sole discretion, deems the documents insufficient, the Issuer shall
            be entitled to instruct the Acquirer or Dillipay to reverse the
            debit and credit the Chargeback Amount to the Customer’s payment
            instrument. If Dillipay is charged the Chargeback Amount by the
            Acquirer or the Issuer, Dillipay shall be entitled to recover such
            Chargeback Amount from the Client by deducting the same from any
            subsequent settlement amounts due to the Client. In the event the
            available settlement amounts are insufficient to cover the
            Chargeback Amount, Dillipay shall be entitled to issue a debit note
            to the Client, and the Client shall reimburse the Chargeback Amount
            within thirty (30) days from receipt of such debit note.
            Furthermore, upon issuance of a termination notice under this
            Agreement, Dillipay shall be entitled to withhold, from each
            settlement made during the notice period, a sum calculated based on
            the stipulated percentage—being the proportion of the total
            Chargeback Amounts to the aggregate Transaction Amounts settled
            during the term of this Agreement—for a period of one hundred and
            twenty (120) days from the date of termination (“Withholding Term”).
            The withheld sums shall be utilized solely for the settlement of
            post-termination Chargebacks, and any unutilized balance shall be
            refunded to the Client forthwith upon expiry of the Withholding
            Term.
          </p>

          <h2
            style={{
              marginTop: "40px",
              marginBottom: "10px",
              fontSize: "20px",
              marginLeft: "20px",
            }}
          >
            22. LITIGATION
          </h2>

          <p style={{ marginBottom: "20px", marginLeft: "20px" }}>
            No claim, action, suit, arbitration, or other legal proceeding shall
            be initiated or maintained by the Retailer against DilliPay
            Technologies Limited (“DilliPay”) in respect of any matter, dispute,
            It is expressly agreed that this Retailer Agreement, and any rights
            and obligations arising hereunder, shall be governed by and
            construed in accordance with the laws of India, including but not
            limited to the Indian Contract Act, 1872, the Information Technology
            Act, 2000, the Arbitration and Conciliation Act, 1996 (as amended),
            and other applicable laws in force from time to time. The Parties
            further agree that any dispute which cannot be resolved amicably
            within the aforesaid notice period shall, subject to the provisions
            of this Agreement, fall exclusively within the jurisdiction of the
            competent courts at Delhi, India, to the exclusion of all other
            courts, tribunals, or fora, whether local, national, or
            international, and the Parties hereby irrevocably submit themselves
            to such jurisdiction.
          </p>
          <h2
            style={{
              marginTop: "40px",
              marginBottom: "10px",
              fontSize: "20px",
              marginLeft: "20px",
            }}
          >
            23. RESTRICTIONS ON LIABILITY
          </h2>
          <ul style={{ marginLeft: "40px", marginBottom: "20px" }}>
            <li style={{ marginBottom: "10px" }}>
              a. Dillipay shall not be liable to the Client for certain types of
              losses or damages, including loss of profit, goodwill, business or
              business opportunity, anticipated savings, special, indirect, or
              consequential damages, or any loss that is an indirect or
              secondary consequence of any act or omission of the party.
            </li>
            <li style={{ marginBottom: "10px" }}>
              b. The total liability of Dillipay towards the Client shall be
              limited in all circumstances to the value of the specific
              transaction under dispute.
            </li>
            <li style={{ marginBottom: "10px" }}>
              c. Dillipay shall have no obligations to the Client and/or its
              customers, other than crediting the transaction value back into
              the Client’s wallet, in the event of any loss or damage arising
              out of or in connection with this Agreement, any breach or
              non-performance by such party of any of its undertakings,
              warranties, covenants, declarations, or obligations under this
              Agreement, or otherwise in contract, tort (including negligence or
              breach of statutory duty), misrepresentation, or otherwise.
            </li>
          </ul>
          <div
            style={{
              marginTop: "30px",
              marginLeft: "20px",
              lineHeight: "1.6",
              fontSize: "16px",
              textAlign: "justify",
            }}
          >
            <h2
              style={{
                fontSize: "20px",
                marginBottom: "10px",
                textTransform: "uppercase",
              }}
            >
              Retailer’s / Legal Declaration for Responsible Use of Payment
              Gateway & UPI/QR Collection Provided by Dillipay
            </h2>

            <p>
              This Declaration is made and executed on this ___ day of
              _________, 2025
              <br />
              By: [_______________Legal Name], A company/firm duly incorporated
              and existing under the laws of [New Delhi], having its registered
              office at [Complete Registered Address], bearing business
              registration number [CIN/LLPIN/Business ID], (hereinafter referred
              to as the “Retailer/ Distributor/ Master Distributor /User ” or
              “Declarant”, which expression shall, unless repugnant to the
              context, include its successors, legal representatives, and
              permitted assigns).
            </p>

            <p>
              <strong>IN FAVOUR OF: DILLIPAY TECHNOLOGIES LIMITED </strong>a
              company incorporated under the Companies Act, 2013, having its
              registered office at [Plot no.-5 2nd floor, pocket-5, sector-24,
              Rohini-110085], (hereinafter referred to as “DILLIPAY” or the
              “Service Provider”, which expression shall include its affiliates,
              successors, and assigns).
            </p>

            <p>
              <strong>WHEREAS:</strong> The Retailer/ Distributor/ Master
              Distributor /User intends to avail Payment Gateway & UPI/QR
              COLLECTION from DILLIPAY for the purpose of enabling digital
              payment collection from its customers for goods and/or services
              offered; DILLIPAY has agreed to provide such services, subject to
              compliance with applicable laws, internal risk policies, and
              commercial terms.
            </p>

            <p>
              The Retailer/ Distributor/ Master Distributor /User is required to
              make the following representations, warranties, and undertakings
              as a condition to avail and continue using DILLIPAY's services.
            </p>

            <p>
              <strong>NOW THEREFORE,</strong> the Retailer/ Distributor/ Master
              Distributor /User hereby declares and undertakes as follows:
            </p>

            <p>
              <strong> This Declaration is made by</strong> Retailer/
              Distributor/ Master Distributor /User{" "}
              <strong>
                (hereinafter referred to as “User/You”) engaged in providing
                Payment Gateway (PG) and Quick Response (QR) Code collection
                services through [Company Name] (hereinafter referred to as “the
                Service Provider”).
              </strong>
            </p>

            <p>
              Whereas, in compliance with the provisions of the{" "}
              <strong>Reserve Bank of India (RBI) regulations</strong>, the
              <strong> Information Technology Act, 2000, </strong>and other
              applicable laws governing digital payments and prevention of
              financial fraud, the following terms and conditions shall strictly
              apply for all PG & QR transactions carried out by
              Retailers/Retailers/Users.
            </p>

            <h3 style={{ marginTop: "20px" }}>1. Purpose of Use</h3>
            <p>
              The Retailer/ Distributor/ Master Distributor /User shall use
              DILLIPAY’s Payment Gateway & UPI/QR COLLECTION exclusively for
              processing payments for actual and verifiable transactions
              involving lawful goods or services provided by them to customers.
              They shall not use the service for high-risk or restricted
              activities without DILLIPAY’s prior consent.
            </p>

            <h3 style={{ marginTop: "20px" }}>2. Terms & Conditions</h3>
            <ul style={{ marginLeft: "20px" }}>
              <li style={{ marginBottom: "10px" }}>
                <strong>Mandatory KYC Verification:</strong>
                <ul
                  style={{
                    marginLeft: "30px",
                    listStyleType: "disc",
                    marginTop: "5px",
                  }}
                >
                  <li>
                    Prior to initiating any PG or QR-based payment transaction,
                    the Retailer/Retailer/ Distributor/ Master Distributor /User
                    must obtain complete KYC details of the cardholder,
                    including:
                  </li>
                  <li>Full Name (as per card)</li>
                  <li>
                    Card Number (only last 4 digits to be stored, as per RBI
                    PCI-DSS norms)
                  </li>
                  <li>
                    Valid Government-issued ID proof (Aadhaar, PAN, Passport,
                    Driving License, or Voter ID)
                  </li>
                  <li>
                    The Retailer/Retailer/ Distributor/ Master Distributor /User
                    must verify the ID proof against the payment instrument to
                    confirm the cardholder’s identity.
                  </li>
                </ul>
              </li>

              <li style={{ marginBottom: "10px" }}>
                <strong>Restriction on Third-Party Payments:</strong>
                <span></span>
                <ul
                  style={{
                    marginLeft: "30px",
                    listStyleType: "disc",
                    marginTop: "5px",
                  }}
                >
                  <li>
                    Payments made through Credit Cards, Debit Cards, or QR Codes
                    shall be accepted only from the actual cardholder/account
                    holder.
                  </li>
                  <li>
                    Under no circumstances shall a Retailer/Retailer/
                    Distributor/ Master Distributor /User allow payments from a
                    credit/debit card on behalf of a third party.
                  </li>
                  <li>
                    The registered mobile number linked to the cardholder’s ID
                    shall be mandatory for validation.
                  </li>
                </ul>
              </li>

              <li style={{ marginBottom: "10px" }}>
                <strong>Record Maintenance & Customer Signature:</strong>
                It is compulsory for the Retailer/Retailer/ Distributor/ Master
                Distributor /User to:
                <ul
                  style={{
                    marginLeft: "30px",
                    listStyleType: "disc",
                    marginTop: "5px",
                  }}
                >
                  <li>
                    Maintain a copy of the cardholder’s ID proof with consent
                    for verification purposes.
                  </li>
                  <li>
                    Record the customer’s signature in a physical register for
                    every transaction, which shall act as proof of
                    authorization.
                  </li>
                  <li>
                    Keep such records updated and readily available for
                    inspection whenever required by the Service Provider, banks,
                    or regulators.
                  </li>
                  <li>
                    Such documents must be stored securely in compliance with
                    RBI Guidelines on Data Protection and the Information
                    Technology (Reasonable Security Practices and Procedures)
                    Rules, 2011.
                  </li>
                  <li>
                    No sensitive card details (like CVV or PIN) shall be stored,
                    in compliance with PCI-DSS standards.
                  </li>
                </ul>
              </li>

              <li>
                <strong>
                  Liability for Chargebacks & Fraudulent Transactions:
                </strong>
                Upon receipt of a Chargeback notification from the Acquirer or
                the Issuer, Dillipay shall forthwith notify the Client. The
                Client shall have the right to submit to Dillipay, within five
                (5) days from such notification (or within such other period as
                may be specified by the Acquirer), documentary evidence and
                information (“Chargeback Documents”) substantiating the
                completion of the underlying transaction and/or the delivery of
                goods or services to the Customer. In the event the Client fails
                to furnish the Chargeback Documents within the stipulated
                period, or if the Issuer, at its sole discretion, deems the
                documents insufficient, the Issuer shall be entitled to instruct
                the Acquirer or Dillipay to reverse the debit and credit the
                Chargeback Amount to the Customer’s payment instrument. If
                Dillipay is charged the Chargeback Amount by the Acquirer or the
                Issuer, Dillipay shall be entitled to recover such Chargeback
                Amount from the Client by deducting the same from any subsequent
                settlement amounts due to the Client. In the event the available
                settlement amounts are insufficient to cover the Chargeback
                Amount, Dillipay shall be entitled to issue a debit note to the
                Client, and the Client shall reimburse the Chargeback Amount
                within thirty (30) days from receipt of such debit note.
                Furthermore, upon issuance of a termination notice under this
                Agreement, Dillipay shall be entitled to withhold, from each
                settlement made during the notice period, a sum calculated based
                on the stipulated percentage—being the proportion of the total
                Chargeback Amounts to the aggregate Transaction Amounts settled
                during the term of this Agreement—for a period of one hundred
                and twenty (120) days from the date of termination ("Withholding
                Term"). The withheld sums shall be utilized solely for
                settlement of post-termination Chargebacks, and any unutilized
                balance shall be refunded to the Client forthwith upon expiry of
                the Withholding Term.
              </li>
            </ul>

            <p style={{ marginLeft: "30px" }}>
              The Retailer/Retailer/ Distributor/ Master Distributor /User
              hereby declares and accepts that if they fail to:
              <ul
                style={{
                  marginLeft: "30px",
                  listStyleType: "disc",
                  marginTop: "5px",
                }}
              >
                <li>
                  Maintain KYC records, ID proofs, or customer signatures; or
                </li>
                <li>
                  Ensure that payments are received only from the cardholder; or
                </li>
                <li>
                  Adhere to the above Terms & Conditions, then in such cases,
                  <strong>
                    {" "}
                    any chargeback, dispute, penalty, or fraudulent transaction
                    arising therefrom shall be the sole responsibility of the
                    Retailer/Retailer/ Distributor/ Master Distributor /User .{" "}
                  </strong>{" "}
                </li>
              </ul>
            </p>
            <p style={{ marginLeft: "30px" }}>
              The Retailer/ Distributor/ Master Distributor /User hereby
              acknowledges and agrees that any violation, breach, or failure to
              comply with the Company’s rules, regulations, or agreed terms
              under this Agreement shall attract consequences as prescribed
              under this Agreement and/or applicable law. The Client further
              undertakes to strictly adhere to all mandatory compliances, and
              understands that in the event of any non-compliance, negligence,
              or irresponsibility on their part, the Client shall be solely
              liable to bear the following
            </p>
            <ul
              style={{
                marginLeft: "30px",
                listStyleType: "disc",
                marginTop: "5px",
              }}
            >
              <li style={{ fontWeight: "bold" }}>
                All legal costs and expenses incurred by the Company
              </li>
              <li style={{ fontWeight: "bold" }}>
                Full reimbursement of any fraudulent amounts, if applicable.
              </li>
              <li style={{ fontWeight: "bold" }}>
                Penalties with full fraudulent amount or charges imposed by any
                competent authority.
              </li>
              <li style={{ fontWeight: "bold" }}>
                Compensation for business losses suffered by the Company,
                calculated on a daily basis until rectification of the default.
              </li>
            </ul>
            <p style={{ marginLeft: "30px" }}>
              <li>
                <strong>Declaration of Adherence</strong>
              </li>
              By signing this Declaration, the Retailer/Retailer/ Distributor/
              Master Distributor /User acknowledges and accepts that:
              <ul
                style={{
                  marginLeft: "30px",
                  listStyleType: "disc",
                  marginTop: "5px",
                }}
              >
                <li>
                  They have read, understood, and agreed to abide by the above
                  Terms & Conditions.
                </li>
                <li>
                  They shall exercise utmost caution and diligence while
                  providing PG & QR COLLECTION.
                </li>
                <li>
                  They are fully responsible for ensuring lawful and compliant
                  usage of such services.
                </li>
              </ul>
            </p>
            <h3 style={{ marginTop: "20px" }}>
              3. Restricted and Prohibited Activities
            </h3>
            <p>
              The Retailer/ Distributor/ Master Distributor /User shall not use
              the services of <strong> DilliPay Technologies Pvt. Ltd.</strong>{" "}
              for any unlawful, unauthorized, or non-compliant transactions.
              This includes but is not limited to: counterfeit or banned goods
              and services; adult or obscene content (unless expressly permitted
              and approved); online betting, gambling, lotteries, or real-money
              gaming (restricted under Indian law); fundraising, crowd funding,
              or political donations without prior approvals and statutory
              clearances; transactions in crypto currencies, NFTs, or virtual
              digital assets unless specifically allowed by regulators; and any
              activity linked to money laundering, terror financing, or
              violations of applicable laws, RBI/SEBI directions, or regulatory
              guidelines. Any breach of these restrictions shall be treated as a
              material violation of terms and may result in suspension or
              termination of services, along with full liability on the
              Retailer/ Distributor/ Master Distributor /User for regulatory
              consequences.
            </p>

            <h3 style={{ marginTop: "20px" }}>
              4. Compliance with Laws and Regulations
            </h3>
            <p>
              <strong>
                4.1 The Parties shall ensure compliance with all applicable
                laws, regulations, and guidelines, including but not limited to:
              </strong>
              <ul
                style={{
                  marginLeft: "30px",
                  listStyleType: "disc",
                  marginTop: "5px",
                }}
              >
                <li>The Information Technology Act, 2000;</li>
                <li>
                  The Prevention of Money Laundering Act, 2002 (PMLA) and rules
                  thereunder;
                </li>
                <li>
                  Applicable guidelines, circulars, and directions issued by the
                  Reserve Bank of India (RBI) and the National Payments
                  Corporation of India (NPCI) with respect to digital payments,
                  UPI, IMPS, AEPS, and related payment systems;
                </li>
                <li>
                  The Goods and Services Tax Act, 2017 (GST) and rules framed
                  thereunder;
                </li>
                <li>
                  Applicable data protection, privacy, and consumer protection
                  laws in India.
                </li>
              </ul>
              <strong> 4.2 </strong>The Retailer/ Distributor/ Master
              Distributor /User shall submit all necessary KYC documents,
              business licenses, tax registrations, and any other documentation
              required by DILLIPAY or regulatory authorities.
            </p>

            <h3 style={{ marginTop: "20px" }}>
              5. Consumer Protection & Transparency
            </h3>
            <ul style={{ marginLeft: "40px", lineHeight: "1.6" }}>
              <li style={{ marginBottom: "10px" }}>
                <strong>5.1</strong> The Retailer/ Distributor/ Master
                Distributor /User shall ensure transparent communication of
                product or service details, pricing, return and refund policies,
                delivery timelines, and terms of sale on its platform or point
                of sale. All terms must be clearly visible and accessible to the
                customer before payment is initiated.
              </li>
              <li>
                <strong>5.2</strong> The Retailer/ Distributor/ Master
                Distributor /User shall honor all customer refund requests as
                per applicable law and internal policy, and shall cooperate in
                all chargeback and dispute resolution processes initiated via
                DILLIPAY. Any failure to process refunds or cooperate in such
                cases may lead to suspension of payment services or legal
                action.
              </li>
            </ul>

            <h3 style={{ marginTop: "20px" }}>6. Data Security and Privacy</h3>
            <ul style={{ marginLeft: "40px", lineHeight: "1.6" }}>
              <li style={{ marginBottom: "10px" }}>
                <strong>6.1</strong> The Retailer/ Distributor/ Master
                Distributor /User shall implement appropriate security measures
                to protect customer data and ensure that customer card or
                payment information is not stored, misused, or compromised. All
                systems and processes handling payment data must use secure
                encryption and access controls as per industry standards.
              </li>
              <li>
                <strong>6.2</strong> The Retailer/ Distributor/ Master
                Distributor /User agrees to comply with all applicable data
                protection laws and industry standards, including PCI DSS
                (Payment Card Industry Data Security Standard) where applicable,
                and ensure that no sensitive customer data such as CVV, PIN, or
                full card numbers are stored under any circumstances.
              </li>
            </ul>
            <h3 style={{ marginTop: "20px" }}>7. Reporting and Cooperation</h3>
            <ul style={{ marginLeft: "40px", lineHeight: "1.6" }}>
              <li style={{ marginBottom: "10px" }}>
                <strong>7.1</strong> The Retailer/ Distributor/ Master
                Distributor /User shall promptly report any unauthorized,
                suspicious, or fraudulent transactions to DILLIPAY and cooperate
                fully in any investigation initiated by DILLIPAY, banks, or
                regulatory authorities. Immediate reporting shall be made
                through official communication channels provided by DILLIPAY.
              </li>
              <li>
                <strong>7.2</strong> The Retailer/ Distributor/ Master
                Distributor /User consents to audit or inspection of its records
                related to transactions processed via DILLIPAY, as and when
                reasonably required. Such cooperation includes providing access
                to transaction logs, KYC documents, and any other relevant
                information necessary for compliance or investigation purposes.
              </li>
            </ul>

            <h3 style={{ marginTop: "20px" }}>
              8. Representations and Warranties
            </h3>
            <ul style={{ marginLeft: "40px", lineHeight: "1.6" }}>
              <li style={{ marginBottom: "10px" }}>
                The Retailer/ Distributor/ Master Distributor /User hereby
                represents and warrants that it is duly organized and validly
                existing under the laws of its jurisdiction.
              </li>
              <li style={{ marginBottom: "10px" }}>
                It has full authority to enter into agreements and declarations
                with DILLIPAY and to perform its obligations as outlined in this
                declaration.
              </li>
              <li style={{ marginBottom: "10px" }}>
                All information, records, and documentation provided to DILLIPAY
                are true, accurate, complete, and kept up-to-date at all times.
              </li>
              <li>
                No proceedings, legal or regulatory, are pending or threatened
                that may restrict or adversely affect its ability to use
                DILLIPAY’s services or perform its obligations under this
                declaration.
              </li>
            </ul>

            <h3 style={{ marginTop: "20px" }}>9. Indemnity</h3>
            <ul style={{ marginLeft: "40px", lineHeight: "1.6" }}>
              <li style={{ marginBottom: "10px" }}>
                The Retailer/ Distributor/ Master Distributor /User agrees to
                indemnify, keep indemnified, and hold harmless DILLIPAY, its
                directors, officers, employees, and agents from any actions,
                proceedings, claims, liabilities, penalties, demands, costs,
                awards, damages, losses, and/or expenses arising out of or in
                connection with the discharge of the scope of work by the
                Retailer/ Distributor/ Master Distributor /User under this
                declaration or agreement.
              </li>
              <li style={{ marginBottom: "10px" }}>
                DILLIPAY may be subjected to such claims either directly or
                through a legal proceeding, and the indemnification shall cover
                any breach or non-performance by the Retailer/ Distributor/
                Master Distributor /User of its undertakings, warranties,
                covenants, declarations, or obligations under this declaration.
              </li>
              <li style={{ marginBottom: "10px" }}>
                The indemnification also extends to any act, neglect, or default
                of the Retailer’s employees or agents, including any claim by a
                third party against DILLIPAY resulting from such acts or
                omissions.
              </li>
              <li style={{ marginBottom: "10px" }}>
                If any proceedings are undertaken that may give rise to the
                Client’s liability under this declaration, DILLIPAY shall
                provide prompt notice to the Retailer/ Distributor/ Master
                Distributor /User and an opportunity to participate in such
                proceedings to represent its interests appropriately.
              </li>
              <li style={{ marginBottom: "10px" }}>
                Notwithstanding anything contained herein, DILLIPAY’s liability
                to the Retailer/ Distributor/ Master Distributor /User for any
                damages shall not exceed the transaction value under dispute.
              </li>
              <li style={{ marginBottom: "10px" }}>
                The indemnification shall also cover any liability or loss
                arising from:
                <ul style={{ marginLeft: "20px", marginTop: "10px" }}>
                  <li>Violation of any applicable law, rule, or regulation;</li>
                  <li>
                    Breach of this Declaration or any agreement with DILLIPAY;
                  </li>
                  <li>
                    Customer complaints, disputes, chargebacks, or fraudulent
                    activities arising due to the acts or omissions of the
                    Retailer/ Distributor/ Master Distributor /User.
                  </li>
                </ul>
              </li>
            </ul>

            <h3 style={{ marginTop: "20px" }}>10. Suspension or Termination</h3>
            <ul style={{ marginLeft: "20px" }}>
              <li>
                DILLIPAY reserves the right to suspend or terminate the
                Retailer’s access to services with or without notice in cases
                of:
                <ul style={{ marginLeft: "20px" }}>
                  <li>Breach of any declaration, law, or terms of service;</li>
                  <li>
                    Repeated chargebacks, fraudulent behavior, or misuse of
                    services;
                  </li>
                  <li>Non-cooperation in compliance or audit matters.</li>
                </ul>
              </li>
              <li>
                Upon termination, the Retailer must immediately stop using
                DILLIPAY services and settle all outstanding dues, refunds, and
                chargebacks.
              </li>
            </ul>

            <h3 style={{ marginTop: "20px" }}>
              11. Governing Law and Jurisdiction
            </h3>
            <p>
              This Declaration shall be governed by the laws of India. Any
              disputes arising out of or in connection with this Declaration
              shall be subject to the exclusive jurisdiction of the courts
              located at [New Delhi].
            </p>

            <h3 style={{ marginTop: "20px" }}>12. Entire Understanding</h3>
            <p>
              This Declaration constitutes the entire understanding between the
              Retailer/ Distributor/ Master Distributor /User and DILLIPAY
              regarding the use of Payment Gateway & UPI/QR COLLECTION and
              supersedes any prior oral or written communications or
              representations.
            </p>

            <h4 style={{ marginTop: "20px" }}>
              Declaration by Retailer/Retailer/ Distributor/ Master Distributor
              /User
            </h4>
            <p>
              I, ____________________________, S/o/D/o ________________________,
              Proprietor/Authorized Signatory of __________________________
              (Shop/Business Name), hereby declare that I have read and
              understood the above Terms & Conditions and agree to comply with
              the same while providing PG & QR payment services.
            </p>

            <p>
              I further declare that I shall compulsorily maintain the ID proof
              and customer signature register for every transaction and accept
              full responsibility for any dispute or fraud arising due to
              non-compliance.
            </p>

            <p>Date: ____________</p>
            <p>Place: ____________</p>
            <p>
              Signature & Stamp: __________________________ (Retailer /
              Distributor / Master Distributor / User)
            </p>

            <p style={{ marginTop: "20px" }}>
              <strong>IN WITNESS WHEREOF,</strong> the undersigned has executed
              this Declaration on the date first mentioned above.
            </p>

            <p>
              For and on behalf of [Retailer’s Legal Name]
              <br />
              (Company Seal & Signature / Authorized Signatory)
              <br />
              Name: ____________________________
            </p>
          </div>

          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "30px",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    border: "1px solid #000",
                    padding: "12px 20px",
                    textAlign: "left",
                    backgroundColor: "#f4f4f4",
                    fontWeight: "bold",
                  }}
                >
                  For and on behalf of:
                </th>
                <th
                  style={{
                    border: "1px solid #000",
                    padding: "12px 20px",
                    textAlign: "left",
                    backgroundColor: "#f4f4f4",
                    fontWeight: "bold",
                  }}
                >
                  For and on behalf of:
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "12px 20px",
                    verticalAlign: "top",
                  }}
                >
                  DILLIPAY TECHNOLOGIES LIMITED
                </td>

                <td
                  style={{
                    border: "1px solid #000",
                    padding: "12px 12px",
                  }}
                >
                  Shop Name :{user.establishment}
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "12px 20px",
                  }}
                >
                  Authorised Signatory -
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "12px 20px",
                  }}
                >
                  Authorised Signatory -
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "12px 20px",
                  }}
                >
                  Name:Tarun
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "12px 20px",
                  }}
                >
                  Name: Tarun
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "12px 20px",
                  }}
                >
                  Designation: Director
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "12px 20px",
                  }}
                >
                  Designation: {user.role}
                </td>
              </tr>
            </tbody>
          </table>
          <br />
          <Box>
            <Text>Signature :</Text>
            <img src={dilliPaysign} />
          </Box>
          <h5
            style={{
              marginTop: "15px",
            }}
          >
            Date:{currentDateTime}
          </h5>
          <h5
            style={{
              marginTop: "5px",
            }}
          >
            Place: {user.state}
          </h5>

          <FormControlLabel
            control={
              <Checkbox
                checked={checked}
                onChange={handleChange}
                color="primary"
                sx={{ transform: "scale(1.2)" }}
              />
            }
            label={
              <Typography
                sx={{ fontSize: "1rem", color: "#333", fontWeight: "500" }}
              >
                I accept
              </Typography>
            }
            sx={{ marginLeft: "8px" }}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
            }}
          >
            {user.name}
            <Text>Authorised Signatory</Text>
          </div>
          {(showForPDF || message) && (
            <>
              <Typography
                style={{
                  fontSize: "1rem",
                  // color:
                  //   message ==
                  //   `This agreement  is electronically transmitted on ${myDateDDMMTT(
                  //     date
                  //   )} from IP address ${stateData.ip}. and verified by (${
                  //     user?.establishment
                  //   }/${user?.name}) having PAN NO ${user?.pan} `
                  //     ? "green"
                  //     : "red",
                  color: stateData.type === "ret_dd" ? "green" : "red",
                  // color: "green",
                  fontWeight: "bold",
                  marginTop: "8px",
                }}
              >
                {console.log(
                  "type",
                  stateData.type,
                  stateData.type === "ret_dd"
                )}
                {message}
              </Typography>
              {message ===
              `This agreement  is electronically transmitted on ${myDateDDMMTT(
                date
              )} from IP address ${stateData.ip}. and verified by (${
                user?.establishment
              }/${user?.name}) having PAN NO ${user?.pan} ` ? (
                <Typography
                  style={{
                    fontSize: "1rem",
                    color: "black",
                    fontWeight: "bold",
                    marginTop: "8px",
                  }}
                >
                  date is: {myDateDDMMTT(date) || "Your have not sign Agrement"}
                </Typography>
              ) : (
                ""
              )}
            </>
          )}

          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                width: 400,
                padding: 2,
                margin: "auto",
                mt: "20vh",
                borderRadius: "8px",
                boxShadow: 24,
                backgroundColor: "#fff",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <ModalHeader
                title="Distributor Agreement"
                handleClose={handleCloseModel}
              />

              <Box sx={{ flexGrow: 1, mt: 2 }}>
                {!isOtpSent && (
                  <div>
                    <TextField
                      label="Aadhaar Number"
                      name="aadhaar"
                      value={aadhaar}
                      variant="outlined"
                      required
                      fullWidth
                      onChange={(e) => setAadhaar(e.target.value)}
                      placeholder="Enter your Aadhaar number"
                      inputProps={{ maxLength: 12 }}
                      sx={{ marginBottom: 2, mt: 2 }}
                    />
                    {aadhaarError && (
                      <FormHelperText error>{aadhaarError}</FormHelperText> // Show error message below Aadhaar field
                    )}
                  </div>
                )}

                <div>
                  {isOtpSent && (
                    <div>
                      <Typography sx={{ mb: 1, ml: 1 }}>Enter Otp</Typography>
                      <PinInput
                        value={otp}
                        onChange={setOtp}
                        length={6}
                        autoComplete="off"
                        focus
                        required
                        type="password"
                        sx={{ marginBottom: 2, mt: 2 }}
                      />
                      {otpError && (
                        <FormHelperText error>{otpError}</FormHelperText> // Show error message below OTP field
                      )}
                    </div>
                  )}
                </div>
              </Box>
              {/* <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  disabled={isOtpSent ? !otp : !aadhaar}
                  sx={{ mr: 1, mt: 1 }}
                >
                  Submit
                </Button>
                <Button
                  onClick={handleClose}
                  color="secondary"
                  sx={{ mr: 1, mt: 1 }}
                >
                  Cancel
                </Button> */}
              <Loader loading={request} />

              <ModalFooter
                btn={"submit"}
                onClick={!isOtpSent ? handleSubmit : verifyOTP}
                style={{
                  backgroundColor:
                    (isOtpSent && otp.length === 6) ||
                    (!isOtpSent && aadhaar.length === 12)
                      ? "#3f51b5"
                      : "#ddd",
                  cursor:
                    (isOtpSent && otp.length === 6) ||
                    (!isOtpSent && aadhaar.length === 12)
                      ? "pointer"
                      : "not-allowed",
                }}
              />
            </Box>
          </Modal>
        </Page>
      </div>
    </>
  );
};

export default DistributorAgreement;
